import React, {useState} from 'react';
import IconTitleButtonRound from "../buttons/IconTitleButtonRound";
import {IsLP_MP_SP} from "my-styles/media/media";
import SwiperCore, {Scrollbar} from 'swiper/core';
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/swiper.min.css";

SwiperCore.use([Scrollbar])

export default function SelectableItemList(props) {

    const [items, setItems] = useState(props.items)

    if (items) {
        return (<div className="fullWidth">
            {IsLP_MP_SP() ?
                <Swiper
                    spaceBetween={5}
                    direction={'horizontal'}
                    className="mySwiper fullWidth"
                    slidesPerView={props.itemsPerView}>
                    {items.map((item, index) => {
                        return <SwiperSlide key={index}>
                            <div style={{marginLeft: props.marginLeft ? props.marginLeft : "0.5em"}}>
                                <IconTitleButtonRound
                                    height={"2.5em"}
                                    direction={"ltr"}
                                    title={item.title}
                                    boxshadow={props.shadow ? props.shadow : ""}
                                    backgroundcolor={item.selected ? "var(--blue_3)" : "var(--gray_1)"}
                                    textcolor={item.selected ? "var(--white)" : "var(--black)"}
                                    icon={item.icon ? (item.selected ? item.selectedIcon : item.icon) : undefined}
                                    fontSize={props.fontSize ? props.fontSize : item.selected ? "mediumTextBold" : "smallTextBold"}
                                    onClick={() => {
                                        for (let i = 0; i < items.length; i++) {
                                            items[i].selected = i === index
                                        }
                                        setItems(items)
                                        if (props.onItemSelected) {
                                            props.onItemSelected(index, item)
                                        }
                                    }}/>
                            </div>
                        </SwiperSlide>
                    })}
                </Swiper> :
                <div className="horizontalFullScreen HScroll">
                    {items.map((item, index) => {
                        return <div key={index} style={{marginLeft: "0.3em", height: "2.8em"}}>
                            <IconTitleButtonRound
                                height={"2.5em"}
                                title={item.title}
                                direction={"ltr"}
                                boxshadow={props.shadow ? props.shadow : ""}
                                backgroundcolor={item.selected ? "var(--blue_3)" : "var(--gray_1)"}
                                textcolor={item.selected ? "var(--white)" : "var(--black)"}
                                icon={item.icon ? (item.selected ? item.selectedIcon : item.icon) : undefined}
                                fontSize={props.fontSize ? props.fontSize : item.selected ? "mediumTextBold" : "smallTextBold"}
                                onClick={() => {
                                    for (let i = 0; i < items.length; i++) {
                                        items[i].selected = i === index
                                    }
                                    setItems(items)

                                    if (props.onItemSelected) {
                                        props.onItemSelected(index, item)
                                    }
                                }}/>
                        </div>
                    })}
                </div>
            }
        </div>)
    } else {
        return (<div/>)
    }

}